import { Injectable, SimpleChanges} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject, map } from 'rxjs';
import { UpcomingDates, SelectableDate } from './upcoming-dates';

@Injectable({
  providedIn: 'root'
})
export class AppointmentPickerPropertiesService {
  selectedTime: number | undefined
  time: string | null = null
  selectedDate: Date | null = null
  selectedSite: string | null = null

  private dateSource = new Subject<Date | null>()

  getDateObservable() {
    return this.dateSource.asObservable()
  }

  clear() {
    this.selectedDate = null 
    this.selectedSite = null
    this.time = null
    this.selectedTime = undefined
    this.dateSource.next(null)
  }

  constructor(private http: HttpClient) { }

  loadAllAppointments(year: number, appointmentType: string, city: string | null): Observable<UpcomingDates> {
    let url = `/api/getAppointmentTimes?year=${year}&appointmentType=${appointmentType}`
    if (city != null) {
      url += `&city=${city}`
    }
    return this.http.get<UpcomingDatesResponse>(url)
      .pipe(map((response) => {
        return response.data
      }));
 }
}

export interface UpcomingDatesResponse {
  data: UpcomingDates
}